import {
  MAX_FILE_SIZE_BYTES,
  MIN_IMG_SIDE_LENGTH,
  MIN_ASPECT_RATIO,
  MAX_ASPECT_RATIO,
} from '@/constants/faceDetection';

function checkFileSizeValid(fileSize) {
  return fileSize < MAX_FILE_SIZE_BYTES;
}

function checkFileResolutionValid(imgWidth, imgHeight) {
  return imgWidth > MIN_IMG_SIDE_LENGTH || imgHeight > MIN_IMG_SIDE_LENGTH;
}

function checkDetectedFaceNumberValid(detections) {
  if (detections.length > 1 && getForegroundFaceId(detections) === -1) {
    return false;
  }
  return true;
}

function getForegroundFaceId(detections) {
  if (detections.length === 2) {
    let maxArea = -Infinity;
    let maxIndex = -1;

    detections.forEach((item, index) => {
      const area = item.roi.h * item.roi.w;

      if (area > maxArea) {
        maxArea = area;
        maxIndex = index;
      }
    });
    return maxIndex;
  }
  return -1;
}

function checkAnyFaceDetected(detections) {
  return detections.length !== 0;
}

function checkAspectRatioRangeValid(ratio) {
  return MIN_ASPECT_RATIO < ratio && ratio < MAX_ASPECT_RATIO;
}

function checkProfileTypeValid(type) {
  return type.includes('image');
}

export {
  checkFileSizeValid,
  checkFileResolutionValid,
  checkDetectedFaceNumberValid,
  checkAnyFaceDetected,
  checkAspectRatioRangeValid,
  checkProfileTypeValid,
};
